import React from 'react';
import { FeatureList } from 'components/core/FeatureList';
import { SelfStorage, Mover, ReserveOnline, NoCredit } from 'components/svg';
import { H4 } from 'components/core/Typography';

import './HowItWorksFeatures.scss';

export const howItWorksFeatures = [
	{
		title: '1. Select your storage unit',
		svg: ReserveOnline
	},
	{
		title: '2. Reserve for free',
		description: 'Cancel or change your reservation at any time, risk-free',
		svg: NoCredit
	},
	{
		title: '3. Visit your facility',
		svg: SelfStorage
	},
	{
		title: '4. Move in',
		svg: Mover
	}
];

export default function HowItWorksFeatures() {
	return (
		<div className="how-it-works-features">
			<H4
				size="medium"
				className="feature-list-title"
			>
				How it works
			</H4>
			<FeatureList
				features={howItWorksFeatures}
			/>
		</div>
	);
}
